<template>
  <div
    v-show="isShowForm"
    class="flex-content"
    style="height: 100%; overflow: hidden; background-color: #fff"
  >
    <!-- <a href="/register" class="registered">注册</a> -->
    <div class="login-bg"></div>
    <!-- <div><img src="/img/icon_login.ceec4f44.png" alt="" /></div> -->
    <div class="form-wrapper">
      <!-- 登录方式1：验证码 -->
      <div class="login-form input-title" v-show="loginway === '1'">
        <login-form
          :isStyle01="true"
          @submit="submit"
          :btnText="btnText"
          :is-submit-disabled-f="isSubmitDisabledF"
        ></login-form>
        <p class="oth-switch loginIdWord">
          <a href="javascript:void(0)" class="fl" @click="switchLoginWay">账号密码登录</a>
          <a href="/register" class="red_color">注册</a>
          <a href="/maintainAdminLogin" class="fr gray_color width">维修人员登录</a>
        </p>
      </div>
      <!-- 登录方式2：账号密码 -->
      <div class="login-form input-title" v-show="loginway === '2'">
        <login-form
          :isStyle02="true"
          :isLogin="true"
          @submit="submit"
          :btnText="btnText"
          :is-submit-disabled-f="isSubmitDisabledF"
        ></login-form>
        <p class="oth-switch">
          <a href="javascript:void(0)" class="fl" @click="switchLoginWay">验证码登录</a>
          <a href="/register" class="red_color">注册</a>
          <router-link to="/getpsw" class="fr gray_color">忘记密码？</router-link>
        </p>
      </div>
    </div>
    <AgreementList style="flex: 1" @click-check="clickCheck"></AgreementList>
    <Foot class="Foot"></Foot>
  </div>
</template>

<script>
import Foot from "../../components/Foot.vue";
import LoginForm from "./component/LoginForm";
import { loginByVerf, loginByOpenId, loginByPsw, saveInfo } from "network/login";
import AgreementList from "../../components/AgreementList.vue";
export default {
  name: "Login",
  components: {
    LoginForm,
    Foot,
    AgreementList,
  },
  data() {
    return {
      btnText: "登录", //登录按钮文案
      loginway: "1", //登录方式
      isSubmitDisabledF: false, //禁止点击
      // redirectURL: "", // 来源页redirectURL
      isShowForm: false, // 是否显示登录表单
      isother: false, // 是否显示其他登录方式
      studentId: "",
      isShowConfirm: false,
      isRegister: false,
      isClickCheck: false,
    };
  },
  computed: {
    frontStageDomain() {
      return frontStageDomain;
    },
    isLogin() {
      return localStorage.getItem("isLogin");
    },

    redirectURL() {
      const url = this.$route.query.redirectURL || localStorage.getItem("redirectURL");
      return url ? url : null;
    },
    openIdStorage() {
      const wxOpenId = localStorage.getItem("wxOpenId") || "";
      return wxOpenId && wxOpenId.length > 0 ? wxOpenId : "";
    },
  },
  watch: {},
  created() {
    // console.log(this.$route.params,"判断从找回密码页回来时展示账号密码登录");
    // 判断从找回密码页回来时展示账号密码登录
    if (this.$route.params) {
      var logWay = this.$route.params.way;
      if (logWay == 2) {
        this.loginway = "2";
      } else {
        this.loginway = "1";
      }
    } else {
      this.loginway = "1";
    }
    // 非微信环境登录逻辑：
    // ①localStorage中存在openId则直接openId登录，不存在则显示表单登录
    // ②openId登录失败，则显示表单登录
    // ③当由于身份过期导致退出登录,则判断localStorage是否存在openId,存在则自动登录,否则退出跳转登录页(判断代码在login.js→logOut方法中)
    console.log(this.openIdStorage);
    if (this.openIdStorage != "") {
      this.loginByOpenIdFun(this.openIdStorage);
      return false;
    }
    this.isShowForm = true;
  },
  mounted() {
    document.body.style.backgroundColor = "#ffffff";
  },
  methods: {
    // 选择隐私协议
    clickCheck(val) {
      this.isClickCheck = val;
    },
    // 切换登录方式
    switchLoginWay() {
      const loginway = this.loginway;
      if (loginway === "1") {
        this.loginway = "2";
      } else {
        this.loginway = "1";
      }
    },
    // 登录提交数据
    submit(val) {
      const loginway = this.loginway;
      if (!this.isClickCheck) {
        this.$confirm.show("请勾选下方协议");
        return;
      }
      this.$loading.show("登录中…");
      if (loginway === "1") {
        this.btnText = "登录中";
        this.isSubmitDisabledF = true;
        // alert(this.openIdStorage);
        //  验证码登录
        loginByVerf(val.telInput, val.verfVal, this.openIdStorage, this.isRegister)
          .then((res) => {
            console.log(res, "验证码登录");
            if (res.data && res.data.access_token) {
              saveInfo(res.data, this.redirectURL);
            } else {
              this.$confirm.show(res.data.error || eresrr.data.message);
            }
          })
          .catch((err) => {
            console.log(err);
            this.btnText = "登录";
            this.isSubmitDisabledF = false;
            this.$loading.hide();
            this.$confirm.show(err.data.error || err.data.message);
          });
      } else {
        this.btnText = "登录中";
        this.isSubmitDisabledF = true;
        // alert(this.openIdStorage)
        //  密码登录
        loginByPsw(val.telInput, val.pswInput, this.openIdStorage)
          .then((res) => {
            console.log(res, "密码登录");
            if (res.data && res.data.access_token) {
              saveInfo(res.data, this.redirectURL);
            } else {
              this.$confirm.show(res.data.error || eresrr.data.message);
            }
          })
          .catch((err) => {
            console.log(err);
            this.btnText = "登录";
            this.isSubmitDisabledF = false;
            this.$loading.hide();
            this.$confirm.show(err.data.error || err.data.message);
          });
      }
    },
    // 微信openId登录方法
    loginByOpenIdFun(openId) {
      // var type = localStorage.getItem("port") || "";
      loginByOpenId(openId)
        .then((res) => {
          // alert("Login页面openid登录返回数据：" + JSON.stringify(res));
          if (res.data && res.data.access_token) {
            saveInfo(res.data, this.redirectURL);
          } else {
            this.isShowForm = true;
          }
        })
        .catch((err) => {
          this.isShowForm = true;
        });
    },
  },
  beforeDestroy() {},
};
</script>

<style scoped src="./login_style.css"></style>
